import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirm-delete-form-dialog',
  templateUrl: './confirm-delete-form-dialog.component.html',
  styleUrls: ['./confirm-delete-form-dialog.component.scss']
})
export class ConfirmDeleteFormDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
